import { isMobile } from 'react-device-detect';

export const isTouchDevice = () => {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
};

export const isDesktopDevice = () => {
  return !isMobile;
};

export const isMobileDevice = () => {
  const isPortrait = window.innerHeight > window.innerWidth;
  return isMobile && isPortrait;
};

export const isShipPlacementMobile = () => {
  const isPortrait = window.innerHeight > window.innerWidth;
  return isMobile && isPortrait;
};